enum ModalEnum {
    Alert = 'alert',
    Danger = 'danger',
    Confirm = 'confirm',
    Success = 'success',
    Error = 'error',
    TCloud = 't-cloud',
    Attach = 'attach',
    Viewer = 'viewer',

    // Prescriptions
    ChooseTask = 'chooseModal',

    // Design
    SuccessSendModal = 'successSendModal',
    ForceEndTaskModal = 'forceEndTaskModal',
    RemarksImportModal = 'remarksImportModal',

    // ProjectManagement
    ChooseStage = 'chooseStage',
    PhotoUploader = 'photoUploader',
    ConnectionProjectModal = 'connectionProjectModal',
    ConnectionTasksModal = 'connectionTasksModal',
}

export default ModalEnum;
